import { analyticsService } from "@/api/services/analyticsService";
import { pixelFromGaEvent } from "@/utils/metaPixel";

// Contact method -> backend AnalyticsEventType
const CONTACT_EVENT_TYPE = {
  call:       "BUSINESS_PHONE_CLICK",
  whatsapp:   "BUSINESS_WHATSAPP_CLICK",
  website:    "BUSINESS_WEBSITE_CLICK",
  directions: "BUSINESS_DIRECTIONS_CLICK",
  social:     "BUSINESS_SOCIAL_CLICK",
};

/** True only when the visitor accepted analytics cookies (gates third-party GA4). */
function analyticsConsentGranted() {
  try {
    const raw = localStorage.getItem("fg_cookie_consent");
    return raw ? JSON.parse(raw)?.analytics === true : false;
  } catch {
    return false;
  }
}

/**
 * Send a GA4 event. No-ops if gtag isn't loaded or the visitor hasn't
 * consented to analytics cookies.
 */
export function trackEvent(name, params = {}) {
  if (
    typeof window !== "undefined" &&
    typeof window.gtag === "function" &&
    analyticsConsentGranted()
  ) {
    window.gtag("event", name, params);
  }
  // Also feed the Meta Pixel (self-gated on MARKETING consent, separate from GA4).
  pixelFromGaEvent(name, params);
}

/**
 * Record a contact action on a business. Writes to two sinks:
 *  1. First-party analytics (backend) — aggregate, no user PII — always sent,
 *     consistent with existing BUSINESS_VIEW/BUSINESS_SAVE tracking. Powers the
 *     owner dashboard "Contacts" stats.
 *  2. GA4 (marketing funnel) — consent-gated inside trackEvent.
 *
 * @param {'call'|'whatsapp'|'website'|'directions'|'social'} method
 * @param {{id: string|number, name?: string}} business
 * @param {string} [detail] e.g. the social platform ('instagram')
 */
export function trackContact(method, business, detail) {
  const eventType = CONTACT_EVENT_TYPE[method];
  if (!eventType || !business?.id) return;

  analyticsService.track({
    businessId: parseInt(business.id, 10),
    eventType,
    source: "DIRECT",
    ...(detail ? { metadata: { detail } } : {}),
  }).catch(() => {});

  trackEvent("business_contact", {
    contact_method: method,
    business_id: String(business.id),
    business_name: business.name,
    ...(detail ? { contact_detail: detail } : {}),
  });
}
